import { render, staticRenderFns } from "./page4.vue?vue&type=template&id=773c8496&scoped=true&"
import script from "./page4.vue?vue&type=script&lang=js&"
export * from "./page4.vue?vue&type=script&lang=js&"
import style0 from "./page4.vue?vue&type=style&index=0&id=773c8496&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773c8496",
  null
  
)

export default component.exports